/**
 * Environment Configuration
 * Centralized environment variables for the frontend
 */

export const config = {
  // API Configuration
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:5000',
  
  // App Configuration
  appName: import.meta.env.VITE_APP_NAME || 'Niko Vibe',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  
  // Cloudinary Configuration
  cloudinary: {
    cloudName: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
    apiKey: import.meta.env.VITE_CLOUDINARY_API_KEY,
  },
  
  // Google Analytics
  gaTrackingId: import.meta.env.VITE_GA_TRACKING_ID,
  
  // Feature Flags
  features: {
    analytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    notifications: import.meta.env.VITE_ENABLE_NOTIFICATIONS !== 'false',
    offlineMode: import.meta.env.VITE_ENABLE_OFFLINE_MODE === 'true',
  },
  
  // Development
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};

export default config;
